<div
  *ngIf="showLoader || (!showRetry && !stopWaiting); else retry"
  class="loader-container"
  [class]="class"
  [style.minHeight]="containerHeight || ''"
  [class.loader-container--small]="isInner"
  [class.loader-container--fixed]="isOverlay"
>
  <div class="loader" [class.loader--small]="small">
    <div class="loader-cube"></div>
    <div class="loader-cube"></div>
    <div class="loader-cube"></div>
    <div class="loader-cube"></div>
    <div class="loader-cube"></div>
    <div class="loader-cube"></div>
    <div class="loader-cube"></div>
    <div class="loader-cube"></div>
    <div class="loader-cube"></div>
  </div>
  <ng-content></ng-content>
</div>
<ng-template #retry>
  <div [class]="class" [ngClass]="{'loader-container loader-container--fixed': isOverlay}" class="retry-container">
    <retry *ngIf="!retryCb; else blockScopedRetry"></retry>
    <ng-template #blockScopedRetry>
      <pac-retry-block-scoped (retry)="retryCb()"></pac-retry-block-scoped>
    </ng-template>
  </div>
</ng-template>
